export enum ErrorMessageContent {
    SomethingWentWrong = "Something went wrong.",
    NoDataToDisplay = "No data to display.",
    NotAuthenticated = "You are not authenticated.",
    NoPageAccess = "You do not have access to this resource. Please contact support if you believe this is incorrect.",
    NoDashboardAccess = "You do not have access to PAR OPS Coach.",
    NoCoachDetectAccess = "You do not have access to PAR OPS Detect.",
    NoDeliveryOperationsAccess = "You do not have access to PAR OPS Delivery Operations.",
    WrongAppParameters = "You do not have access to this resource. Application parameters are invalid or not set correctly."
}

export enum HttpErrorType {
    Abort = "AbortError",
    Network = "NetworkError",
    TypeError = "TypeError",
    Timeout = "TimeoutError",
    HttpError = "HttpError",
    SyntaxError = "SyntaxError",
    Cors = "CorsError"
}
